import * as Yup from "yup";

export const verifyEmailForMetamaskValidationSchema = Yup.object().shape({
  email: Yup.string().email().required(""),
  confirmationEmail: Yup.string()
    .email()
    .oneOf([Yup.ref("email"), null], "*The emails doesn't match!"),
});
